export const VIDEOS_EMPTY_STATE_TITLE =
  "You haven't posted a video from Headliner yet";

export const VIDEOS_EMPTY_STATE_DESCRIPTION =
  'Any time you use Headliner to post videos directly to YouTube or social media platforms, your engagement data will be reported on here! This allows you to see views, likes, and comments, all in one place.';
